export const breakPoints = {
	mobile: "576px",
	tablet: "768px",
	desktop: "992px",
	wide: "1200px",
}